module.exports = __webpack_public_path__ + "img/fig6.c83e567b.png";